// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculator":"_14uNQw","modal":"ckGERK","open":"APHSC4"};